import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-estrutura-detalhe',
    standalone: true,
    imports: [],
    templateUrl: './estrutura-organizacional-detalhe.html',
    styleUrl: './estrutura-organizacional-detalhe.scss'
})
/** Painel de detalhe da estrutura organizacional selecionada. */
export class EstruturaOrganizacionalDetalhe {
    private readonly route = inject(ActivatedRoute);

    get idEstrutura(): number | null {
        const id = Number(this.route.snapshot.paramMap.get('id'));
        return Number.isFinite(id) && id > 0 ? id : null;
    }
}
